const Video = () => {
    const container = document.querySelectorAll('.js-content-video');
    if (!container.length)
        return;
    container.forEach(element => {
        const overlay = element.querySelector('.js-video-overlay');
        const video = element.querySelector('video');
        if (overlay && video) {
            overlay.addEventListener('click', () => {
                overlay.classList.add('hidden');
                video.play();
                video.setAttribute('controls', 'true');
            });
        }
    });
};
export default Video;
